// GET Parties list endpoint
export const getPartiesApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/parties${queryString ? `?${queryString}` : ""}`;
};

export const getRoleListApi = (params, query) => {
    return `/party_roles?lite=true`
}

// GET Parties detail endpoint (if you need slug)
export const getPartiesDetailApi = (params) => {
    return `lease/${params?.leaseSlug}/parties`;
};

// POST new Parties
export const addPartiesApi = (params) => {
    return `lease/${params?.leaseSlug}/parties`;
};

// PUT edit Parties
export const updatePartiesApi = (params) => {
    return `lease/${params?.leaseSlug}/parties/${params?.slug}`;
};

// DELETE Parties
export const deletePartiesApi = (params) => {
    return `lease/${params?.leaseSlug}/parties`;
};

// EXPORT Partiess
export const exportPartiesApi = (leaseId) => {
    return `lease/${leaseId}/parties`;
};



export const partyfileUploadPostApi = (parties_slug) => {
    return `/get-pre-signed-url/party/${parties_slug}`;
};

export const partyAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/party/${attachments_slug}`
}